import { render, staticRenderFns } from "./IframeDialog.vue?vue&type=template&id=c40e7a1a"
import script from "./IframeDialog.vue?vue&type=script&lang=js"
export * from "./IframeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports